import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { AuthProvider } from './context/AuthContext';
import MobileLayout from './components/layout/MobileLayout';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import AdminLayout from './pages/admin/AdminLayout';
import AdminLogin from './pages/admin/AdminLogin';
import Dashboard from './pages/admin/Dashboard';
import Users from './pages/admin/Users';
import AdminInvitations from './pages/admin/Invitations';
import EmailTemplates from './pages/admin/EmailTemplates';
import Reports from './pages/admin/Reports';
import Settings from './pages/admin/Settings';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ConfirmEmail from './pages/ConfirmEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Home from './pages/Home';
import CreateChoice from './pages/CreateChoice';
import CreateSingles from './pages/singles/CreateSingles';
import CreateCouples from './pages/couples/CreateCouples';
import InviteView from './pages/InviteFlow/InviteView';
import ReplyEnvelope from './pages/Envelope/ReplyEnvelope';
import Invitations from './pages/Invitations';
import Profile from './pages/Profile';
import Onboarding from './pages/Onboarding';
import MusicAdmin from './pages/admin/MusicAdmin';
import Placeholder from './pages/Placeholder';
import './index.css';

function App() {
  return (
    <AuthProvider>
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/confirm-email" element={<ConfirmEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/invite/:id" element={<InviteView />} />
            <Route path="/reply/:id" element={<ReplyEnvelope />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route element={<ProtectedRoute><MobileLayout /></ProtectedRoute>}>
              <Route path="/home" element={<Home />} />
              <Route path="/onboarding" element={<Onboarding />} />
              <Route path="/invitations" element={<Invitations />} />
              <Route path="/moments" element={<Placeholder title="Moments" icon="Image" />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/create" element={<CreateChoice />} />
              <Route path="/create/singles" element={<CreateSingles />} />
              <Route path="/create/couples" element={<CreateCouples />} />
              <Route path="/edit/singles/:token" element={<CreateSingles />} />
              <Route path="/edit/couples/:token" element={<CreateCouples />} />
            </Route>
            <Route element={<AdminRoute><AdminLayout /></AdminRoute>}>
              <Route path="/admin" element={<Dashboard />} />
              <Route path="/admin/users" element={<Users />} />
              <Route path="/admin/invitations" element={<AdminInvitations />} />
              <Route path="/admin/templates" element={<EmailTemplates />} />
              <Route path="/admin/music" element={<MusicAdmin />} />
              <Route path="/admin/reports" element={<Reports />} />
              <Route path="/admin/settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AppProvider>
    </AuthProvider>
  );
}

export default App;